<template>
    <div>
        <v-data-table
            loading-text="Loading..."
            :disable-filtering="true"
            :disable-sort="true"
            :loading="logs.loading"
            :headers="logs.headers"
            :items="logs.items"
            :options.sync="logs.options"
            :items-per-page="logs.options.itemsPerPage"
            :server-items-length="logs.totals"
            :item-class="rowClass"
            :footer-props="{
                showFirstLastPage: true,
                showCurrentPage: true,
                disableItemsPerPage: true,
                itemsPerPageOptions: [logs.options.itemsPerPage]
            }">
            <template v-slot:item.sent_date="{ item }">
                <span class="text--secondary text-caption">{{ item.sent_date }} {{ item.sent_time }}</span>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-btn
                    small
                    color="primary"
                    @click="openLog(item)">
                    Open
                </v-btn>
            </template>
        </v-data-table>

        <v-navigation-drawer
            v-model="log.view"
            absolute
            temporary
            right
            width="75%"
            color="white"
        >
            <template v-slot:prepend>
                <v-list-item two-line>
                    <v-list-item-avatar>
                        <v-icon x-large>mdi-email-open</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title>
                            {{ log.item.to }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="text--secondary text-subtitle-2">
                            Sent Date: {{ log.item.sent_date }} {{ log.item.sent_time }}
                        </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                        <v-btn icon @click.stop="closeLog()">
                            <v-icon large>mdi-close</v-icon>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
            </template>

            <v-divider></v-divider>

            <v-tabs
                v-model="log.tab"
                background-color="primary"
                dark
                fixed-tabs
            >
                <v-tabs-slider></v-tabs-slider>

                <v-tab href="#tab-body">
                    Body
                </v-tab>

                <v-tab href="#tab-headers">
                    Headers
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="log.tab">
                <v-tab-item
                    value="tab-body"
                >
                    <v-card flat>
                        <v-card-text v-html="log.item.body"></v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item
                    value="tab-headers"
                >
                    <v-card flat>
                        <v-card-text v-html="log.item.headers"></v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-navigation-drawer>
    </div>
</template>

<script>
export default {
    data() {
        return {
            logs: {
                options: {
                    page: 1,
                    itemsPerPage: 20
                },
                loading: false,
                totals: 0,
                headers: [
                    {
                        text: 'To',
                        value: 'to',
                    },
                    {
                        text: 'Subject',
                        value: 'subject',
                    },
                    {
                        text: 'Sent Data',
                        value: 'sent_date',
                    },
                    {
                        text: 'Actions',
                        value: 'actions',
                        align: 'end'
                    },
                ],
                items: []
            },
            log: {
                view: false,
                item: {},
                tab: null,
            },
        }
    },

    watch: {
        'logs.options.page'(new_val, old_val) {
            this.pullLogs();
        },
    },

    mounted() {
        this.pullLogs();
    },

    methods: {
        rowClass(item) {
            return '';
        },

        openLog(item) {
            this.log.view = !this.log.view;
            this.log.item = item;
        },

        closeLog() {
            this.log.view = false
        },

        pullLogs() {
            (new DBEmailLogs(this))
                .addParam('page', this.logs.options.page)
                .before(() => {
                    this.logs.loading = true;
                })
                .after(response => {
                    this.logs.loading = false;
                    this.logs.totals = response.data.data.total;
                    this.logs.items = response.data.data.data;
                    this.logs.options.page = response.data.data.current_page;
                    this.logs.options.itemsPerPage = response.data.data.per_page;
                })
                .error(error => {
                    this.logs.loading = false;
                })
                .get();
        }
    }
}
</script>
